<template>
  <text-input
    v-bind="{ label: showLabel, required }"
    type="password"
    :value="fieldValue"
    @input="updatePassword"
    :error="$root.errorBag[field]">
    {{ label }}
  </text-input>
</template>
<script>

export default {

  props: {
    store: {
      type: String,
      default: 'user'
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      required: true,
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    mutation: {
      type: String,
      default: ''
    }
  },
  
  methods: {
    updatePassword(value) {
      this.$store.commit(`${this.store}/${this.mutation}`, value)
    }
  },

  computed: {
    fieldValue() {
      return this.$store.getters[`${this.store}/user`][this.field]
    },
    showLabel() {
      return (this.label.length > 0)
    }
  }

}
</script>